export const MULTISIG_KEY = "multisig";
